<template>
    <div class="app has-header">
        <div class="header main">

            <div class="align-left">
                <dateselectionheader v-if="viewState === 2"
                        :label="dateSelectionStart.format('YYYY')"
                        @PrevDate="setDateSelection(dateSelectionStart.add(-1, 'year'), true)"
                        @NextDate="setDateSelection(dateSelectionStart.add(1, 'year'), true)"
                        @CalendarOpen="OpenDateSelection"
                        @SetToday="setDateSelection($helpers.getCurrentMonthMomentTZ(), true)"/>

            </div>

            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
            </div>
            <!--<div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <datatablepaging :pageLength="20" :maxItems="DataTableFilteredItems().length" @update="(options) => { pageOptions = options }" />
            <datatabletextfilter @update="SetFilterText"></datatabletextfilter>
            <datatablefilter :filterOptionsState="dataTableFilterOptions" @update="(filtersSelected) => { filters = filtersSelected }" />  -->
        </div>
        <div class ="tablecontainer crew-labor-container scrollbar-container" :class="anonMode ? 'anonblur' : ''">
            <datatable :state="planningGroupTableState" v-if="viewState == 1 && !loading"/>
            <datatable :state="crewLaborPlanningTableState" v-if="viewState == 2 && !loading"/>
        </div>

        <!--<datatable :state="dataTableState" :pageState="pageOptions" :filterState="filters" :filterCheckState="dataTableFilterOptions" :rowSelect="true" @rows-selected="UpdateRows"/> -->

        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <!--<div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>-->
        </div>
    </div>

</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'crewlaborplanning',
    components: {
        datatable,
    },
  data () {
    return {
        planningIndicatorTypeMap: {},
        planningGroupMap: {},
        crewlaborEntryMonthMap: {},
        dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ(),
        viewState: 1,
        loading: true,
        currentGroup: null,
        editFlag: false,
    }
  },
  
  created: function () {
    if(this.rosterFromTo != null){
        let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
        this.setDateSelection(startDate, true);
    } else {
        this.setDateSelection(this.$helpers.getCurrentMonthMomentTZ(), true);
    }
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  computed: {
        ...mapGetters(['anonMode', 'storeId', 'rosterFromTo', 'crewlaborPlanningMap', 'planningEmployeeMap', 'spotMap']),
        headerButtons(){

                let view = this;

                let state= {
                    buttons: []
                };
                state.buttons.push({
                    type: "block",
                    icon: "fa-sync-alt",
                    click: () => {
                        if(view.viewState == 2) {
                            view.RefreshCrewLaborPlanning();
                        } else {
                            view.refresh(true);
                        }
                    },
                    tooltip: this.$t('global.general.refreshData'),
                    helperText: this.$t('indicator.crew.reloadDataGui')
                });
                if(this.viewState == 1){
                    state.buttons.push({type: "block green", icon: "fa-plus",click: ($event) => {view.AddPlanningGroup($event)},tooltip: this.$t('indicator.crew.addPlanning'),
                    helperText: this.$t('indicator.crew.budgetHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/2680913955"
                    });
                }
                if(this.viewState == 2){
                    state.buttons.push({type: "block green", icon: "fa-plus",click: ($event) => {view.AddCrewLaborPlanning($event)},tooltip: this.$t('indicator.crew.addPlanning'),
                                        helperText: this.$t('indicator.crew.budgetHelp'),
                                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/2680913955"});
                    state.buttons.push({type: "block",icon: "fa-undo-alt",click: () => {view.viewState = 1},tooltip: this.$t('indicator.main.backToOverview'), helperText: this.$t('indicator.crew.returnToOverview') });
                    //state.buttons.push({type: "block",icon: "fa-file-import",click: () => {view.ImportPlanningIndicators()},tooltip: 'Kennzahlen importieren'});
                    state.buttons.push({type: "block yellow",icon: "fa-user",click: () => {view.OpenCrewPlanningHelperPopup()},tooltip: this.$t('indicator.crew.openPersonnelPlanning'), helperText: this.$t('indicator.crew.openPersonnelPopup')});
                    
                    state.buttons.push({type: "block green", show: view.editFlag, icon: "fa-save",click: () => {view.createCrewLaborPlanningMulti(Object.values(view.crewlaborEntryMonthMap))},tooltip: this.$t('global.ui.saveChanges'), helperText: this.$t('indicator.crew.saveChangesHelp')});
                    
                }
               
                state.helperLinks = [
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close')
                    }
                ];
                
                return state;
        },
        planningIndicatorTypes(){
            return Object.values(this.planningIndicatorTypeMap);
        },
        planningGroups(){
            return Object.values(this.planningGroupMap);
        },
        selectedGroup(){
            return this.planningGroupMap[this.currentGroup];
        },
        inputFactor() {
            return this.selectedGroup ? Math.pow(10, this.planningIndicatorTypeMap[this.selectedGroup.input].fractional) : 1;
        },
        outputFactor() {
            return this.selectedGroup ? Math.pow(10, this.planningIndicatorTypeMap[this.selectedGroup.output].fractional) : 1;
        },
        monthSelectionItems() {
            let view = this;

            let months = [];
            let tempDate = this.$helpers.getCurrentMonthMomentTZ();
            for(let i = 0; i < 12; i++){
                let item = {label: view.$helpers.translateMonth(tempDate.month(i).format("MMMM")), value: i+1, data: null};
                months.push(item);
            }
            return months;
        },
        planningEmployeeMonthStats(){
            let map = {}
            const crewlaborMonthMap = this.crewlaborEntryMonthMap;
            const planningEmployeeMap = this.planningEmployeeMap;
            for(let i = 1; i < 13; i++){
                let monthSummary = {avgWage: 0, vacationTime: 0, workTime: 0};
                let crewLaborPlanning = crewlaborMonthMap[i];
                if(crewLaborPlanning){
                    let employees = Object.values(planningEmployeeMap).filter(item => item.planningId == crewLaborPlanning.id);
                    let sumWage = 0;
                    let totalCount = 0;
                    employees.forEach(item => {
                        sumWage += item.count*item.wage;
                        
                        monthSummary.vacationTime += item.count*(item.vacationTime/(12*24*60))*(item.workTime/(4.325 * 5)); //count * avg vacation DAYS / month * workValue of a vacation Day
                        monthSummary.workTime += item.count*item.workTime;
                        totalCount += item.count;
                    });
                    if(totalCount > 0){
                        monthSummary.avgWage = sumWage/totalCount;
                    }
                }
                
                map[i] = monthSummary;
            }
            
            return map;
        },
        crewLaborStatsMonthMap() {
            let map = {};
            const crewlaborMonthMap = this.crewlaborEntryMonthMap;
            const employeeStatsMap = this.planningEmployeeMonthStats;
            let totalVacationHours = Object.values(employeeStatsMap).map(item => item.vacationTime).reduce((a, b) => a + b, 0) / 60;
            

            for(let i = 1; i < 13; i++){
                let monthStats = {productiveHours: 0, outputProductivity: 0, outputCL: 0, vacationHours: 0, leftTotalHours: 0,  leftTotalCosts: 0,  leftCL: 0, rightTotalCosts: 0, rightCL: 0,};
                
                let crewLaborPlanning = crewlaborMonthMap[i];
                if(crewLaborPlanning){
                    let output = crewLaborPlanning.outputValue / this.outputFactor;
                    monthStats.productiveHours =  crewLaborPlanning.inputValue / crewLaborPlanning.productivity;  //in HOURS
                    monthStats.outputProductivity = output / monthStats.productiveHours;
                    monthStats.outputCL = output > 0 ? (monthStats.productiveHours * employeeStatsMap[i].avgWage / output) : 0;
                    monthStats.vacationHours = (crewLaborPlanning.vacationPercentage/100)/100 * totalVacationHours;
                    
                    monthStats.leftTotalHours = (monthStats.productiveHours + monthStats.vacationHours +crewLaborPlanning.sickTime/60 + crewLaborPlanning.unproductiveTime/60);
                    monthStats.leftTotalCosts = Math.round(monthStats.leftTotalHours * employeeStatsMap[i].avgWage + crewLaborPlanning.additionalCost);
                    if(monthStats.leftTotalCosts <= 0){
                        monthStats.leftCL = 0;
                    } else if(output <= 0){
                        monthStats.leftCL = Infinity;
                    } else {
                        monthStats.leftCL = (monthStats.leftTotalCosts/100) / output;
                    }
                    monthStats.rightTotalCosts = (employeeStatsMap[i].workTime/60) * employeeStatsMap[i].avgWage + crewLaborPlanning.additionalCost;
                    if(monthStats.rightTotalCosts <= 0){
                        monthStats.rightCL = 0;
                    } else if(output <= 0){
                        monthStats.rightCL = Infinity;
                    } else {
                        monthStats.rightCL = (monthStats.rightTotalCosts/100) / output;
                    }
                }
                
                map[i] = monthStats;
            }
            return map;
        },
        crewLaborSummary() {
            let summary = {month: this.$helpers.getCurrentMonthMomentTZ(), outputValue: 0, inputValue: 0, productivity: 0, productiveHours: 0, outputProductivity: 0, outputCL: 0, 
                           sickTime: 0, unproductiveTime: 0, vacationPercentage: 0, vacationHours: 0, leftTotalHours: 0, additionalCost: 0, avgWage: 0, leftTotalCosts: 0,
                           leftCL: 0, rightTotalCosts: 0, rightCL: 0}
            const crewlaborEntryMonthMap = this.crewlaborEntryMonthMap;
            const employeeStatsMap = this.planningEmployeeMonthStats;
            const crewLaborStatsMonthMap = this.crewLaborStatsMonthMap;
            Object.values(crewlaborEntryMonthMap).forEach(item => {
                summary.outputValue+=item.outputValue;
                summary.inputValue+=item.inputValue;
                summary.productivity+=item.productivity;
                summary.productiveHours += crewLaborStatsMonthMap[item.month].productiveHours;
                summary.outputProductivity += crewLaborStatsMonthMap[item.month].outputProductivity;
                summary.outputCL += crewLaborStatsMonthMap[item.month].outputCL;
                summary.vacationPercentage+=item.vacationPercentage;
                summary.vacationHours += crewLaborStatsMonthMap[item.month].vacationHours;
                summary.sickTime+=item.sickTime;
                summary.unproductiveTime+=item.unproductiveTime;
                summary.additionalCost+=item.additionalCost;
                summary.avgWage += employeeStatsMap[item.month].avgWage;
                summary.leftTotalHours += crewLaborStatsMonthMap[item.month].leftTotalHours;
                summary.leftTotalCosts += crewLaborStatsMonthMap[item.month].leftTotalCosts;
                summary.rightTotalCosts += crewLaborStatsMonthMap[item.month].rightTotalCosts;
            })
            summary.productivity = summary.productivity/12;
            summary.avgWage = summary.avgWage/12;
            summary.outputProductivity = summary.outputProductivity/12;
            summary.outputCL = summary.outputCL/12;
            summary.rightCL = (summary.rightTotalCosts/100) / (summary.outputValue/this.outputFactor);
            summary.leftCL = (summary.leftTotalCosts/100) / (summary.outputValue/this.outputFactor);

            return summary;

        },
        planningGroupTableState(){
            let view = this;
            let state = {};
            
            state = this.$helpers.GetDataTableStateFromObject({name: '',output: '', input: ''}, this.planningGroups);
            state.headerMap['name'].sort = true;
            state.headerMap['name'].align = 'center';
            state.headerMap['name'].label = this.$t('pages.employeeData.name');
            state.headerMap['name'].DisplayLabel = (i) => {return i.name};
            state.headerMap['output'].sort = false;
            state.headerMap['output'].align = 'center';
            state.headerMap['output'].label = this.$t('indicator.crew.outputQuantity');
            state.headerMap['output'].DisplayLabel = (i) => {return view.planningIndicatorTypeMap[i.output].name};
            state.headerMap['input'].sort = false;
            state.headerMap['input'].align = 'center';
            state.headerMap['input'].label = this.$t('indicator.crew.quantityUsed');
            state.headerMap['input'].DisplayLabel = (i) => {return view.planningIndicatorTypeMap[i.input].name};
            
            
            state.headerMap['actions'] = {align: 'center',
                buttons:[ 
                        {icon: 'fas fa-eye', action: ($event, data) => view.selectGroup(data)},
                        {icon: 'fas fa-trash', action: ($event, data) => view.DeletePlanningGroupModal($event, data)},
                ]
            };
            state.headerMap['actions'].width = '100px';
            return state;
        },
        crewLaborPlanningTableState(){
            console.log("AAA")
            let view = this;
            let state = {};
            let tempDate = this.$helpers.getCurrentMonthMomentTZ();
            const crewLaborStatsMonthMap = this.crewLaborStatsMonthMap;
            const employeeStatsMap = this.planningEmployeeMonthStats;
            const crewLaborSummary = this.crewLaborSummary;
            state = this.$helpers.GetDataTableStateFromObject({month: '', outputValue: 0, inputValue: 0, productivity: 0, productiveHours: 0, outputProductivity: 0, outputCL: 0, 
                                                               sickTime: 0, unproductiveTime: 0, vacationPercentage: 0, vacationHours: 0, leftTotalHours: 0, additionalCost: 0, avgWage: 0, leftTotalCosts: 0,
                                                               leftCL: 0, rightTotalCosts: 0, rightCL: 0}, Object.values(this.crewlaborEntryMonthMap)); 
            state.headerMap['month'].sort = false;
            state.headerMap['month'].align = 'center';
            state.headerMap['month'].label = this.$tc('global.general.month');
            state.headerMap['month'].DisplayLabel = (i) => {return tempDate.month(i.month-1).format('MMMM')};
            state.headerMap['outputValue'].sort = false;
            state.headerMap['outputValue'].align = 'center';
            state.headerMap['outputValue'].label = this.planningIndicatorTypeMap[this.selectedGroup.output].name;
            state.headerMap['outputValue'].DisplayLabel = (i) => {return (i.outputValue / view.outputFactor).toFixed(2)};
            state.headerMap['outputValue'].OnChange = (newVal, rowData, headerKey) => {
                rowData.outputValue = newVal * view.outputFactor;
                view.editFlag = true;
            };
            state.headerMap['outputValue'].OnChangeColor="#FFFF99";

            /* example of inputbutton
            state.headerMap['outputValue'].componentTypeRow="inputbutton";
            state.headerMap['outputValue'].componentStateBuilder = (rowitemData, entry) => {
                return {
                    state: {value: 'test'},
                    customEvents: {
                        'arrow-up' : (value) => {console.log('arrow-up')},
                        'arrow-down' : (value) => {console.log('arrow-down')},
                        'input-change' : (value) => {console.log(value)},
                    }
                }
            };
            //more example
            state.headerMap['name'].stylesEntry = {background: "#ccc"};
            //anything that would need this updated needs to do $forceUpdate on the datatable
            state.headerMap['name'].stylesEntryComputed = (entry, rowItemData) =>  {
                if(view.planningIndicatorTypeMap[rowItemData.input].name === 'Cars') return {background: "#ccc"}
                else return {};
            };
            */


            state.headerMap['inputValue'].sort = false;
            state.headerMap['inputValue'].align = 'center';
            state.headerMap['inputValue'].label = this.planningIndicatorTypeMap[this.selectedGroup.input].name;
            state.headerMap['inputValue'].DisplayLabel = (i) => {return (i.inputValue / view.inputFactor).toFixed(2)};
            state.headerMap['inputValue'].OnChangeColor="#FFFF99";
            state.headerMap['inputValue'].OnChange = (newVal, rowData, headerKey) => {
                rowData.inputValue = newVal * view.inputFactor;
                view.editFlag = true;
            };


            state.headerMap['productivity'].sort = false;
            state.headerMap['productivity'].align = 'center';
            state.headerMap['productivity'].label = this.$t('roster.view.prodShort');
            state.headerMap['productivity'].tooltip = this.$t('roster.view.productivity');
            state.headerMap['productivity'].DisplayLabel = (i) => {return (i.productivity / view.inputFactor).toFixed(2)};
            state.headerMap['productivity'].OnChangeColor="#FFFF99";
            state.headerMap['productivity'].OnChange = (newVal, rowData, headerKey) => {
                rowData.productivity = newVal * view.inputFactor;
                view.editFlag = true;
                
            };
            state.headerMap['productiveHours'].sort = false;
            state.headerMap['productiveHours'].align = 'center';
            state.headerMap['productiveHours'].label = this.$t('indicator.crew.prodHoursShort');
            state.headerMap['productiveHours'].tooltip = this.$t('indicator.crew.prodHours');
            state.headerMap['productiveHours'].DisplayLabel = (i) => {return (crewLaborStatsMonthMap[i.month].productiveHours).toFixed(2)};
            
            state.headerMap['outputProductivity'].sort = false;
            state.headerMap['outputProductivity'].align = 'center';
            state.headerMap['outputProductivity'].label = this.$t('indicator.crew.iProd');
            state.headerMap['outputProductivity'].tooltip = this.planningIndicatorTypeMap[this.selectedGroup.output].name+" " + this.$t('roster.view.productivity');
            state.headerMap['outputProductivity'].DisplayLabel = (i) => {return (crewLaborStatsMonthMap[i.month].outputProductivity).toFixed(2)};

            state.headerMap['outputCL'].sort = false;
            state.headerMap['outputCL'].align = 'center';
            state.headerMap['outputCL'].label = this.$t('indicator.crew.prodCrewLaborShort');
            state.headerMap['outputCL'].tooltip = this.$t('indicator.crew.prodCrewLabor');
            state.headerMap['outputCL'].DisplayLabel = (i) => {return (crewLaborStatsMonthMap[i.month].outputCL).toFixed(2)+'%'};
            
            state.headerMap['unproductiveTime'].sort = false;
            state.headerMap['unproductiveTime'].align = 'center';
            state.headerMap['unproductiveTime'].label = this.$t('indicator.crew.unprodHoursShort');
            state.headerMap['unproductiveTime'].tooltip = this.$t('indicator.crew.unprodHours');
            state.headerMap['unproductiveTime'].DisplayLabel = (i) => {return (i.unproductiveTime / 60).toFixed(2)};
            state.headerMap['unproductiveTime'].OnChangeColor="#FFFF99";
            state.headerMap['unproductiveTime'].OnChange = (newVal, rowData, headerKey) => {
                rowData.unproductiveTime = newVal * 60;
                view.editFlag = true;
            };
            
            state.headerMap['sickTime'].sort = false;
            state.headerMap['sickTime'].align = 'center';
            state.headerMap['sickTime'].label = this.$t('indicator.crew.sick');
            state.headerMap['sickTime'].tooltip = this.$t('indicator.crew.sickHours');
            state.headerMap['sickTime'].DisplayLabel = (i) => {return (i.sickTime / 60).toFixed(2)};
            state.headerMap['sickTime'].OnChangeColor="#FFFF99";
            state.headerMap['sickTime'].OnChange = (newVal, rowData, headerKey) => {
                rowData.sickTime = newVal * 60;
                view.editFlag = true;
            };
            
            state.headerMap['vacationPercentage'].sort = false;
            state.headerMap['vacationPercentage'].align = 'center';
            state.headerMap['vacationPercentage'].label = this.$t('indicator.crew.vacationReductionShort');
            state.headerMap['vacationPercentage'].tooltip = this.$t('indicator.crew.vacationReductionPercent');
            state.headerMap['vacationPercentage'].DisplayLabel = (i) => {return (i.vacationPercentage / 100).toFixed(2)+'%'};
            state.headerMap['vacationPercentage'].OnChangeColor="#FFFF99";
            state.headerMap['vacationPercentage'].componentTypeRow="inputbutton";
            state.headerMap['vacationPercentage'].componentStateBuilder = (rowData, entry) => {
                return {
                    state: {value: rowData.vacationPercentage / 100},
                    customEvents: {
                        'arrow-up' : (value) => {rowData.vacationPercentage += 10; view.editFlag = true;},
                        'arrow-down' : (value) => {rowData.vacationPercentage -= 10; view.editFlag = true;},
                        'input-change' : (value) => {rowData.vacationPercentage = value*100; view.editFlag = true;},
                    }
                }
            }; 

            state.headerMap['vacationHours'].sort = false;
            state.headerMap['vacationHours'].align = 'center';
            state.headerMap['vacationHours'].label = this.$t('indicator.crew.vacationHoursShort');
            state.headerMap['vacationHours'].tooltip = this.$t('indicator.crew.vacationReductionHours');
            state.headerMap['vacationHours'].DisplayLabel = (i) => {return (crewLaborStatsMonthMap[i.month].vacationHours).toFixed(2)};
            
            state.headerMap['leftTotalHours'].sort = false;
            state.headerMap['leftTotalHours'].align = 'center';
            state.headerMap['leftTotalHours'].label = this.$tc('global.ui.hours');
            state.headerMap['leftTotalHours'].DisplayLabel = (i) => {return (crewLaborStatsMonthMap[i.month].leftTotalHours).toFixed(2)};

            state.headerMap['avgWage'].sort = false;
            state.headerMap['avgWage'].align = 'center';
            state.headerMap['avgWage'].label = this.$t('indicator.crew.wage');
            state.headerMap['avgWage'].DisplayLabel = (i) => {return (employeeStatsMap[i.month].avgWage / 100).toFixed(2)};

            state.headerMap['additionalCost'].sort = false;
            state.headerMap['additionalCost'].align = 'center';
            state.headerMap['additionalCost'].label = this.$t('indicator.crew.extraPay');
            state.headerMap['additionalCost'].DisplayLabel = (i) => {return (i.additionalCost / 100).toFixed(2)};
            state.headerMap['additionalCost'].OnChangeColor="#FFFF99";
            state.headerMap['additionalCost'].OnChange = (newVal, rowData, headerKey) => {
                rowData.additionalCost = newVal * 100;
                view.editFlag = true;
            };
           
            

            state.headerMap['leftTotalCosts'].sort = false;
            state.headerMap['leftTotalCosts'].align = 'center';
            state.headerMap['leftTotalCosts'].label = this.$t('indicator.crew.planCosts');
            state.headerMap['leftTotalCosts'].DisplayLabel = (i) => {return (crewLaborStatsMonthMap[i.month].leftTotalCosts / 100).toFixed(2)};
            
            state.headerMap['leftCL'].sort = false;
            state.headerMap['leftCL'].align = 'center';
            state.headerMap['leftCL'].label = this.$t('indicator.crew.planCrewLaborShort');
            state.headerMap['leftCL'].tooltip = this.$t('indicator.crew.planCrewLabor');
            state.headerMap['leftCL'].DisplayLabel = (i) => {return (crewLaborStatsMonthMap[i.month].leftCL*100).toFixed(2) +'%'};
            
            state.headerMap['rightTotalCosts'].sort = false;
            state.headerMap['rightTotalCosts'].align = 'center';
            state.headerMap['rightTotalCosts'].label = this.$t('indicator.crew.empCostsShort');
            state.headerMap['rightTotalCosts'].tooltip = this.$t('roster.comp.employeeCosts');
            state.headerMap['rightTotalCosts'].DisplayLabel = (i) => {return (crewLaborStatsMonthMap[i.month].rightTotalCosts / 100).toFixed(2)};
            
            state.headerMap['rightCL'].sort = false;
            state.headerMap['rightCL'].align = 'center';
            state.headerMap['rightCL'].label = this.$t('indicator.crew.targetCrewLaborShort');
            state.headerMap['rightCL'].tooltip = this.$t('indicator.crew.plannedEmployeesCrewLabor');
            state.headerMap['rightCL'].DisplayLabel = (i) => {return (crewLaborStatsMonthMap[i.month].rightCL*100).toFixed(2) +'%'};
            
            
            state.headerMap['actions'] = {align: 'center',
                buttons:[ 
                        {icon: 'fas fa-user', action: ($event, data) => view.OpenPlanningEmployeePopup($event, data)},
                        //{icon: 'fas fa-trash', action: ($event, data) => view.DeletePlanningGroupModal($event, data)},
                ]
            };
            state.headerMap['actions'].width = '100px';
            state.dataSum = [];
            let sumRow = {}
            sumRow['month'] = {label: this.$t('global.ui.sum'), key: 'month', align: 'center'};
            sumRow['outputValue'] = {label: (this.crewLaborSummary.outputValue / view.outputFactor).toFixed(2), key: 'outputValue', align: 'center'};
            sumRow['inputValue'] = {label: (this.crewLaborSummary.inputValue / view.inputFactor).toFixed(2), key: 'inputValue', align: 'center'};
            sumRow['productivity'] = {label: '-', key: 'productivity', align: 'center'};
            sumRow['productiveHours'] = {label: this.crewLaborSummary.productiveHours.toFixed(2), key: 'productiveHours', align: 'center'};
            sumRow['outputProductivity'] = {label: this.crewLaborSummary.outputProductivity.toFixed(2), key: 'outputProductivity', align: 'center'};
            sumRow['outputCL'] = {label: this.crewLaborSummary.outputCL.toFixed(2)+'%', key: 'outputCL', align: 'center'};
            
            sumRow['sickTime'] = {label: (this.crewLaborSummary.sickTime / 60).toFixed(2), key: 'sickTime', align: 'center'};
            sumRow['unproductiveTime'] = {label: (this.crewLaborSummary.unproductiveTime / 60).toFixed(2), key: 'unproductiveTime', align: 'center'};
            sumRow['vacationPercentage'] = {label: (this.crewLaborSummary.vacationPercentage / 100).toFixed(2)+'%', key: 'vacationPercentage', align: 'center'};
            sumRow['vacationHours'] = {label: this.crewLaborSummary.vacationHours.toFixed(2), key: 'vacationHours', align: 'center'};
            sumRow['leftTotalHours'] = {label: this.crewLaborSummary.leftTotalHours.toFixed(2), key: 'leftTotalHours', align: 'center'};
            sumRow['avgWage'] = {label: '-', key: 'avgWage', align: 'center'};
            sumRow['additionalCost'] = {label: (this.crewLaborSummary.additionalCost / 100).toFixed(2), key: 'additionalCost', align: 'center'};
            
            sumRow['leftTotalCosts'] = {label: (this.crewLaborSummary.leftTotalCosts / 100).toFixed(2), key: 'leftTotalCosts', align: 'center'};
            sumRow['leftCL'] = {label: (this.crewLaborSummary.leftCL * 100).toFixed(2)+'%', key: 'leftCL', align: 'center'};
            sumRow['rightTotalCosts'] = {label: (this.crewLaborSummary.rightTotalCosts / 100).toFixed(2), key: 'rightTotalCosts', align: 'center'};
            sumRow['rightCL'] = {label: (this.crewLaborSummary.rightCL * 100).toFixed(2)+'%', key: 'rightCL', align: 'center'};

            let avgRow = {}
            avgRow['month'] = {label: this.$t('store.settings.average'), key: 'month', align: 'center'};
            avgRow['outputValue'] = {label: ((this.crewLaborSummary.outputValue / view.outputFactor)/12).toFixed(2), key: 'outputValue', align: 'center'};
            avgRow['inputValue'] = {label: ((this.crewLaborSummary.inputValue / view.inputFactor)/12).toFixed(2), key: 'inputValue', align: 'center'};
            avgRow['productivity'] = {label: (this.crewLaborSummary.productivity / view.inputFactor).toFixed(2), key: 'productivity', align: 'center'};
            avgRow['productiveHours'] = {label: (this.crewLaborSummary.productiveHours/12).toFixed(2), key: 'productiveHours', align: 'center'};
            avgRow['outputProductivity'] = {label: this.crewLaborSummary.outputProductivity.toFixed(2), key: 'outputProductivity', align: 'center'};
            avgRow['outputCL'] = {label: this.crewLaborSummary.outputCL.toFixed(2)+'%', key: 'outputCL', align: 'center'};
            
            avgRow['sickTime'] = {label: ((this.crewLaborSummary.sickTime / 60)/12).toFixed(2), key: 'sickTime', align: 'center'};
            avgRow['unproductiveTime'] = {label: ((this.crewLaborSummary.unproductiveTime / 60)/12).toFixed(2), key: 'unproductiveTime', align: 'center'};
            avgRow['vacationPercentage'] = {label: ((this.crewLaborSummary.vacationPercentage / 100)/12).toFixed(2)+'%', key: 'vacationPercentage', align: 'center'};
            avgRow['vacationHours'] = {label: (this.crewLaborSummary.vacationHours/12).toFixed(2), key: 'vacationHours', align: 'center'};
            avgRow['leftTotalHours'] = {label: (this.crewLaborSummary.leftTotalHours/12).toFixed(2), key: 'leftTotalHours', align: 'center'};
            avgRow['avgWage'] = {label: (this.crewLaborSummary.avgWage / 100).toFixed(2), key: 'avgWage', align: 'center'};
            avgRow['additionalCost'] = {label: ((this.crewLaborSummary.additionalCost / 100)/12).toFixed(2), key: 'additionalCost', align: 'center'};
            
            avgRow['leftTotalCosts'] = {label: ((this.crewLaborSummary.leftTotalCosts / 100)/12).toFixed(2), key: 'leftTotalCosts', align: 'center'};
            avgRow['leftCL'] = {label: (this.crewLaborSummary.leftCL * 100).toFixed(2)+'%', key: 'leftCL', align: 'center'};
            avgRow['rightTotalCosts'] = {label: ((this.crewLaborSummary.rightTotalCosts / 100)/12).toFixed(2), key: 'rightTotalCosts', align: 'center'};
            avgRow['rightCL'] = {label: (this.crewLaborSummary.rightCL * 100).toFixed(2)+'%', key: 'rightCL', align: 'center'};

            state.dataSum.push(sumRow);
            state.dataSum.push(avgRow);  
            return state;
        },
  },
  watch: { 
    rosterFromTo(newVal, oldVal) {
        if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            if(this.viewState == 1){
                 this.refresh();
            } else {
                this.RefreshCrewLaborPlanning();
            }
        }
    },
    storeId(newVal, oldVal) {
        console.log("Changed storeId: "+newVal);
        this.refresh();
    },
    crewlaborPlanningMap(newVal, oldVal) {
        this.BuildCrewlaborEntryMonthMap();
    }
    
  },
  // methods that implement data logic.
  methods: {
    EqualizeToTargetPopup(){
        let view = this;
        

        view.$helpers.OpenPopup({
            elRelative: null,
            type: 'datafill',
            componentState: {
                entries: [
                    {label: this.$t('indicator.crew.vacationReductionPercent'), key: 'vacationPercentage', hidden: false, type: 'numeric', value: 100},
                ],
                selectCallback: function (percentage) {
                    view.equalizeCLToTarget(percentage.vacationPercentage);
                }
              },
              header: this.$t('indicator.crew.targetVacationReduction'),
              expanded: true,
        });
    },
    equalizeCLToTarget(target){
        const employeeStatsMap = this.planningEmployeeMonthStats;
        let totalVacationHours = Object.values(employeeStatsMap).map(item => item.vacationTime).reduce((a, b) => a + b, 0) / 60;
        let vacationGoal = Math.round(totalVacationHours *(target/100));
        let vacationLeftOver = vacationGoal;
        let map = {};

        for(let i = 1; i<13; i++){
            let monthStats = this.crewLaborStatsMonthMap[i];
            let entry = this.crewlaborEntryMonthMap[i];
            let vacationTime = (employeeStatsMap[i].vacationTime*(target/100))/60;
            let vacation = Math.min(vacationLeftOver, Math.round(vacationTime));
            //let vacation = Math.min(vacationLeftOver, Math.round(vacationGoal/12));
            vacationLeftOver = vacationLeftOver - vacation;

            let vacationPercentage = Math.round((vacation/totalVacationHours)*100*100)
            entry.vacationPercentage = vacationPercentage;
            let fixedHours = (entry.vacationPercentage/100)/100 * totalVacationHours + entry.sickTime/60 + entry.unproductiveTime/60;

            let productiveCosts = monthStats.rightTotalCosts - entry.additionalCost - fixedHours*employeeStatsMap[i].avgWage;

            if(productiveCosts > 0){
                let productiveHours = productiveCosts/employeeStatsMap[i].avgWage;
                entry.productivity = Math.round(entry.inputValue / productiveHours)
            }
            map[entry.month] = entry;
        }
        this.editFlag = true;
        this.crewlaborEntryMonthMap = map;
    },
    equalizeCLThroughProductivity(){
        const employeeStatsMap = this.planningEmployeeMonthStats;
        let totalVacationHours = Object.values(employeeStatsMap).map(item => item.vacationTime).reduce((a, b) => a + b, 0) / 60;
        
        let map = {};
        let leftover = 0;
        for(let i = 1; i<13; i++){
            let monthStats = this.crewLaborStatsMonthMap[i];
            let entry = this.crewlaborEntryMonthMap[i];
            let fixedHours = (entry.vacationPercentage/100)/100 * totalVacationHours + entry.sickTime/60 + entry.unproductiveTime/60;

            let productiveCosts = monthStats.rightTotalCosts - entry.additionalCost - fixedHours*employeeStatsMap[i].avgWage;
            if(productiveCosts > 0){
                let productiveHours = productiveCosts/employeeStatsMap[i].avgWage;
                entry.productivity =  Math.round(entry.inputValue / productiveHours)
            }
            map[entry.month] = entry;
        }
        this.editFlag = true;
        this.crewlaborEntryMonthMap = map;
    },
    equalizeCLThroughVacations(){
        const employeeStatsMap = this.planningEmployeeMonthStats;
        let totalVacationHours = Object.values(employeeStatsMap).map(item => item.vacationTime).reduce((a, b) => a + b, 0) / 60;
        
        let map = {};
        let leftover = 0;
        for(let i = 1; i<13; i++){
            let monthStats = this.crewLaborStatsMonthMap[i];
            let entry = this.crewlaborEntryMonthMap[i];
            let vacationCosts = (entry.vacationPercentage/100)/100 * totalVacationHours * employeeStatsMap[i].avgWage;
            if((monthStats.leftTotalCosts - vacationCosts) < (monthStats.rightTotalCosts-leftover)){
                let diffCosts = (monthStats.rightTotalCosts-leftover) - (monthStats.leftTotalCosts - vacationCosts);
                let diffVacationHours = diffCosts / (employeeStatsMap[i].avgWage);
                let vacationPercentage = Math.round((diffVacationHours / totalVacationHours)*100*100);
                entry.vacationPercentage = vacationPercentage;
                leftover = 0;
            } else {
                leftover += (monthStats.leftTotalCosts - monthStats.rightTotalCosts)
            }
            map[entry.month] = entry;
        }
        this.editFlag = true;
        this.crewlaborEntryMonthMap = map;
    },
    
    OpenDateSelection($event){
        let view = this;
        this.$helpers.OpenDatepickerPopup(
            { viewsEnabled: ['D'], date: this.dateSelectionStart.clone() },
            {
                OnDateSelect: (date) => { view.setDateSelection(date) },
            },
            { elRelative: $event ? $event.currentTarget : null });
    },
    setDateSelection(date, calculateRosterFromTo){
        let view = this;
        if(this.dateSelectionStart.month() !== date.month()) requestAnimationFrame(function(){view.refresh();});
        let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
        this.dateSelectionStart = fixedDate;
       
        if(calculateRosterFromTo){
            let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
            
            this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
        } else {
            //dont update vuex from to, only update client side view
        }
    },
    refresh: function() {
        let view = this;
        view.loading = true;
        
        view.viewState = 1;
        this.loadPlanningIndicatorTypes()
        .then(response=>{
            view.updatePlanningIndicatorTypes(response.data);
            view.$helpers.GetSpotMap(false);
            return view.loadPlanningGroups();
           
        }).then(response => {
            view.updatePlanningGroups(response.data);
            view.loading = false;
        })
        .catch(function (error) {
            view.loading = false;
            console.log(error)
        });
    },
    AddPlanningGroup($event){
        let view = this;
        

        view.$helpers.OpenPopup({
            elRelative: $event.currentTarget,
            type: 'datafill',
            componentState: {
                entries: [
                    {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: this.$t('shift.template.planing')},
                    {label: this.$t('indicator.crew.outputQuantity'), key: 'output', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: view.planningIndicatorTypes.map(i => {return {label: i.name, value: i.id, data: i}}),
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            styleLight: true,
                    }},
                    {label: this.$t('indicator.crew.quantityUsed'), key: 'input', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: view.planningIndicatorTypes.map(i => {return {label: i.name, value: i.id, data: i}}),
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            styleLight: true,
                        }},
                ],
                selectCallback: function (planningGroup) {
                    view.createPlanningGroup(planningGroup);
                }
              },
              header: this.$t('indicator.crew.newProductivityPlanning'),
              expanded: true,
              centered: true,
        });
    },
    createPlanningGroup: function(planningGroup){
        let view = this;
        let url = '/api/sec/planninggroup';
        let params = {
            storeId: this.storeId
        }
          
        let payload = {
            storeId: this.storeId,
            name: planningGroup.name,
            input: planningGroup.input,
            output: planningGroup.output,
        };

        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let entry = {};
            entry[response.data.data.id] = response.data.data;
            view.planningGroupMap = Object.assign({}, view.planningGroupMap, entry)
            view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('indicator.crew.planningCreated'));
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('indicator.crew.createPlanningError'));
            console.log(error)
        })

    },
    DeletePlanningGroupModal($event, data){
        let view = this;
        view.$helpers.OpenAlert({header: view.$t('indicator.crew.deleteProductivityPlanning'), description: view.$t('indicator.crew.deleteProductivityPlanningQuery'), callbackAccept: (alert) => {
            alert.hidden = true;
            view.deletePlanningGroup(data);
        }});
    },
    deletePlanningGroup: function(planningGroup){
        let view = this;
        let url = '/api/sec/planninggroup';

        url = this.$helpers.appendParam("id", planningGroup.id, url, '/api/sec/planninggroup');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planninggroup');

        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.$delete(view.planningGroupMap, planningGroup.id);
            view.$helpers.success(view.$t('shift.template.deleted'), view.$t('indicator.crew.planningDeleted'));
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.ui.deleteFailed'), view.$t('indicator.crew.deletePlanningError'));
            console.log(error)
        })

    },
    selectGroup(data){
        this.currentGroup = data.id;
        this.viewState = 2;
        this.RefreshCrewLaborPlanning();
    },
    RefreshCrewLaborPlanning(){
        let view = this;
        view.loading = true;
        
        this.$helpers.GetCrewlaborPlanningMap(true, this.currentGroup, this.rosterFromTo.year)
        .then(map=>{
           
            //view.BuildCrewlaborEntryMonthMap();
            let payload = {ids: []};
            Object.values(map).forEach(item => {
                payload.ids.push(item.id);
            });
            return view.$helpers.GetPlanningEmployeeMap(true, view.currentGroup, view.rosterFromTo.year, payload);
        })
        .then(map=>{
            view.loading = false;
        })
        .catch(function (error) {
            view.loading = false;
            view.$helpers.error(view.$t('indicator.crew.loadingError'), view.$t('indicator.crew.loadPlanningError'));
            console.log(error)
        });
    },
    AddCrewLaborPlanning($event){
        let view = this;

        view.$helpers.OpenPopup({
            elRelative: $event.currentTarget,
            type: 'datafill',
            componentState: {
                entries: [
                    {label: this.$tc('global.general.month'), key: 'month', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: this.monthSelectionItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            styleLight: true,
                    }},
                    {label: this.planningIndicatorTypeMap[this.selectedGroup.output].name, key: 'outputValue', hidden: false, type: 'numeric', value: 1},
                    {label: this.planningIndicatorTypeMap[this.selectedGroup.input].name, key: 'inputValue', hidden: false, type: 'numeric', value: 1},
                    {label: this.$t('roster.view.productivity'), key: 'productivity', hidden: false, type: 'numeric', value: 1},
                    {label: this.$t('indicator.crew.vacationReductionPercent'), key: 'vacationPercentage', hidden: false, type: 'numeric', value: 0},
                    {label: view.$t('indicator.crew.sick') + this.$t('indicator.crew.hourBubble'), key: 'sickTime', hidden: false, type: 'numeric', value: 0},
                    {label: this.$t('roster.view.unproductive') + this.$t('indicator.crew.hourBubble'), key: 'unproductiveTime', hidden: false, type: 'numeric', value: 0},
                    {label: this.$t('indicator.crew.extraPay'), key: 'additionalCost', hidden: false, type: 'numeric', value: 0},
                    {label: this.$t('global.general.year'), key: 'year', hidden: true, type: 'numeric', value: this.rosterFromTo.year},
                    {label: this.$t('shift.main.group'), key: 'groupId', hidden: true, type: 'text', value: this.currentGroup},
                    {label: this.$tc('global.menubar.store'), key: 'storeId', hidden: true, type: 'numeric', value: this.storeId},
                    
                   
                ],
                selectCallback: function (crewLaborPlanning) {
                    crewLaborPlanning.inputValue = crewLaborPlanning.inputValue*view.inputFactor;
                    crewLaborPlanning.outputValue = crewLaborPlanning.outputValue*view.outputFactor;
                    crewLaborPlanning.vacationPercentage = crewLaborPlanning.vacationPercentage * 100;
                    crewLaborPlanning.productivity = crewLaborPlanning.productivity * view.inputFactor;
                    crewLaborPlanning.additionalCost = crewLaborPlanning.additionalCost * 100;
                    crewLaborPlanning.sickTime = crewLaborPlanning.sickTime * 60;
                    crewLaborPlanning.unproductiveTime = crewLaborPlanning.unproductiveTime * 60;
                    view.createCrewLaborPlanning(crewLaborPlanning);
                }
              },
              header: this.$t('pages.positionOverview.newEntry'),
              expanded: true,
              centered: true
        });
    },
    createCrewLaborPlanning: function(crewLaborPlanning){
        let view = this;
        let url = '/api/sec/crewlaborplanning';
        let params = {
            storeId: this.storeId
        }
          
        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: crewLaborPlanning
        }).then(response => {
            
            view.$store.commit("setCrewlaborPlanningMapEntry", response.data.data);
            
            view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('indicator.crew.entryCreated'));
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('indicator.crew.createEntryError'));
            console.log(error)
        })

    },
    createCrewLaborPlanningMulti: function(crewLaborPlannings){
        let view = this;
        let url = '/api/sec/crewlaborplanning/multi';
        let params = {
            storeId: this.storeId
        }
        let payload = {
            requests: crewLaborPlannings
        }
        view.loading = true;
        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let payload = []
            response.data.data.forEach(item => {

                let entry = {mapName: "crewlaborPlanningMap", entity: item};
                payload.push(entry);
                
            })
            view.$store.commit("updateMultiple", payload);
            
            view.editFlag = false;
            view.loading = false;
            view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('indicator.crew.entriesCreated'));
        }).catch(function (error) {
            view.loading = false;
            view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('indicator.crew.createEntriesError'));
            console.log(error)
        })

    },
    OpenPlanningEmployeePopup($event, data){
        let view = this;
        let employeeMap = {};  
        Object.values(this.planningEmployeeMap).filter(item => item.planningId == data.id).forEach(item => {
            employeeMap[item.id] = item;
        });
       
        let state =  {
            planningEmployeeMap: employeeMap,
            crewlaborPlanningId: data.id,
            month: data.month,
            year: data.year
        }     
        view.$helpers.OpenPopup({
            elRelative: $event.currentTarget,
            type: 'planningemployeeoverview',
            componentState: state,
            expanded: true,
            centered: true,
            remainAfterSelect: true,
            width: '1200px',
            header: view.$tc('global.general.employee') + ' ' + view.monthSelectionItems[data.month - 1].label + ' ' + data.year,
            customEventName:"modified-planningemployees",
            customEventHandler:(data) => { 
                if(data.type == "created"){
                    view.$store.commit("setPlanningEmployeeMapEntry", data.data);
                } else if (data.type == "deleted"){
                    view.$store.commit("deletePlanningEmployeeMapEntry", {id: data.data});
                } else if(data.type == "replaced"){
                   
                    let map = {};
                    Object.values(view.planningEmployeeMap).forEach(item => {
                        if(data.planningIds.filter(entry => entry == item.planningId).length == 0){
                            map[item.id] = item;
                        }
                    })
                    
                    data.data.forEach(item => {
                        let entry = {};
                        entry[item.id] = item;
                        map = Object.assign({}, map, entry);
                    })
                    view.$store.commit("setPlanningEmployeeMap", {planningEmployeeMap: map, groupId: view.currentGroup, year: view.rosterFromTo.year});
                }
            }
        });
    },
    OpenCrewPlanningHelperPopup(){
        let view = this;
        let groupMap = {};
        let planningIndicatorTypeMap =  {}; 
        Object.values(this.planningGroupMap).forEach(item => {
            groupMap[item.id] = item;
        });
        Object.values(this.planningIndicatorTypeMap).forEach(item => {
            planningIndicatorTypeMap[item.id] = item;
        });
        let state =  {
            planningGroupMap: groupMap,
            planningIndicatorTypeMap: planningIndicatorTypeMap,
            currentGroup: this.currentGroup
        }    
        view.$helpers.OpenPopup({
            elRelative: null,
            type: 'crewlaborplanninghelper',
            componentState: state,
            expanded: true,
            centered: true,
            scrolling: true,
            remainAfterSelect: false,
            width: 'calc(100vw - 40px)',
            header: view.$t('indicator.crew.personnelPlanning'),
            customEventName:"modified-crewlaborplanning",
            customEventHandler:(data) => { 
                if(data.length > 0){
                    view.createCrewLaborPlanningMulti(data);
                }
               
            }
        });
    },
    BuildCrewlaborEntryMonthMap(){
        let map = {}
        let year = this.dateSelectionStart.year();
        const laborMap = this.crewlaborPlanningMap;
        
        let toCreateEntries = [];
        if(this.selectedGroup){
                
            for(let i = 1; i < 13; i++){
                let tempEntry = {id: "00000000-0000-0000-0000-000000000000", storeId: this.storeId, groupId: this.currentGroup, year: year, month: i, inputValue: 1*this.inputFactor, outputValue: 0, productivity: 1*this.inputFactor, vacationPercentage: 0, sickTime: 0, unproductiveTime: 0, additionalCost: 0};
                map[tempEntry.month] = tempEntry;
                
            }
            Object.values(laborMap).filter(entry => entry.groupId == this.currentGroup).forEach(entry => {
                map[entry.month] = Object.assign({}, entry);
            });
        }
        this.crewlaborEntryMonthMap = map;
        Object.values(map).forEach(entry => {
            if(entry.id == "00000000-0000-0000-0000-000000000000"){
                toCreateEntries.push(entry);
            }
        });
        if(toCreateEntries.length > 0){
            this.createCrewLaborPlanningMulti(toCreateEntries);
        }
    },
    ImportPlanningIndicators(){
        let url = '/api/sec/planningindicator/grouped/month';
        let params = {
            storeId: this.storeId,
            planned: true,
            year: this.rosterFromTo.year,
        }
        let view = this;
        this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            params: params
        }).then(response => {
            response.data.forEach(item => {
                if(item.typeId == view.selectedGroup.output){
                    let entry = {};
                    entry[item.month] = view.crewlaborEntryMonthMap[item.month];
                    entry[item.month].outputValue = item.sumAmount;
                    view.crewlaborEntryMonthMap = Object.assign({}, view.crewlaborEntryMonthMap, entry)
                }
                if(item.typeId == view.selectedGroup.input){
                    let entry = {};
                    entry[item.month] = view.crewlaborEntryMonthMap[item.month];
                    entry[item.month].inputValue = item.sumAmount;
                    view.crewlaborEntryMonthMap = Object.assign({}, view.crewlaborEntryMonthMap, entry)
                }
            });
            view.editFlag = true;
        }).catch(error => {
            view.$helpers.error(view.$t('store.settings.importError'), view.$t('global.notifications.dataLoadingError'));
        })
    },
    loadPlanningIndicatorTypes : function() {
      let url = '/api/sec/planningindicatortype';
      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicatortype');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
			
    },
    loadPlanningGroups : function() {
      let url = '/api/sec/planninggroup';
      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planninggroup');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
			
    },
    
    updatePlanningIndicatorTypes: function(data) {
        this.planningIndicatorTypeMap = {};
        for (let i = 0; i < data.length; i++) {
            this.planningIndicatorTypeMap[data[i].id] = data[i];
        }
    },
    updatePlanningGroups: function(data) {
        this.planningGroupMap = {};
        for (let i = 0; i < data.length; i++) {
            this.planningGroupMap[data[i].id] = data[i];
        }
    },
    
   
    hideModal (ref) {
        this.error=false;
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }
 
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .loading{

        -webkit-filter: none !important;
        filter: none !important;
        position: absolute;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        bottom: 0;
        left: 0;
        top: initial;
        width: 100%;
        height: calc(100vh - 109px);
        background: rgba(0,0,0,.5);
        z-index: 10;
        position: fixed;
    }

    .header > .header.date{
        width: fit-content;
    }

    .paging{
        top: 0;
        bottom: 0;
        right: 250px;
    }

    .header > .text-filter{
        top: 0;
        bottom: 0;
        width: 230px;
        right: 45px;
    }
</style>
